'use client';
import { useEffect, useState } from 'react';
import { SunIcon, MoonIcon } from '@heroicons/react/24/solid';

const STORAGE_KEY = 'sc-theme';

function ThemeToggle() {
  const [activeTheme, setActiveTheme] = useState('ink');

  useEffect(() => {
    const stored = globalThis.localStorage.getItem(STORAGE_KEY);
    const theme = stored === 'cream' ? 'cream' : 'ink';
    setActiveTheme(theme);
    document.documentElement.dataset.theme = theme;
  }, []);

  function handleToggle() {
    const nextTheme = activeTheme === 'ink' ? 'cream' : 'ink';
    setActiveTheme(nextTheme);
    document.documentElement.dataset.theme = nextTheme;
    globalThis.localStorage.setItem(STORAGE_KEY, nextTheme);
  }

  const isCream = activeTheme === 'cream';

  return (
    <button
      type="button"
      className={`swap swap-rotate btn btn-ghost btn-circle ${isCream ? 'swap-active' : ''}`}
      aria-label="Toggle color theme"
      aria-pressed={isCream}
      onClick={handleToggle}
    >
      <SunIcon className="swap-on size-5" />
      <MoonIcon className="swap-off size-5" />
    </button>
  );
}

export default ThemeToggle;